import {
  MediaSequenceBranchMutationCreateRequest,
  MediaSequenceBranchMutationUpdateRequest,
} from 'api/core';
import { useFormContext } from 'react-hook-form';

export const AddProgressBar = () => {
  const { register, setValue, watch } = useFormContext<
    | MediaSequenceBranchMutationCreateRequest
    | MediaSequenceBranchMutationUpdateRequest
  >();

  // TODO: Can we set color based on theme?
  // E.g EDC always gets their accent color (#E39A17).
  if (
    !watch('addProgressBar.progressBarColor') ||
    watch('addProgressBar.progressBarColor')?.includes('000000')
  ) {
    setValue('addProgressBar.progressBarColor', '#E39A17');
  }

  return (
    <>
      <div className="form-control">
        <label className="label">
          <span className="label-text">Farve</span>
        </label>
        <input
          {...register('addProgressBar.progressBarColor', {
            required: true,
          })}
          type="color"
          className="input input-bordered"
        />
      </div>
    </>
  );
};
